import React from "react";
import {
  Star, TrendUp, ChartLineUp, Fire, ArrowsClockwise, Coffee,
  Rocket, Lightning, ThumbsUp, ArrowsLeftRight, Buildings, List, X,
  Sparkle,
} from "@phosphor-icons/react";

const TAB_ITEMS = [
  { k: "signals",     label: "Breakouts",        icon: TrendUp,        adminOnly: false },
  { k: "gainers",     label: "Top Movers",       icon: Fire,           adminOnly: false },
  { k: "sectors",     label: "Sectors",          icon: ChartLineUp,    adminOnly: false },
  { k: "fno",         label: "F&O OI",           icon: ChartLineUp,    adminOnly: false },
  { k: "retest",      label: "Re-Test",          icon: ArrowsClockwise,adminOnly: false },
  { k: "cuphandle",   label: "Cup / Flag / Tri", icon: Coffee,         adminOnly: false },
  { k: "approaching", label: "Approaching",      icon: Rocket,         adminOnly: false },
  { k: "ema",         label: "EMA 10/20 Cross",  icon: ArrowsLeftRight,adminOnly: false, premium: true },
  { k: "goldencross", label: "Golden Cross",     icon: Sparkle,        adminOnly: false, premium: true },
  { k: "institutional", label: "Institutional",  icon: Buildings,      adminOnly: false, premium: true },
  { k: "power",       label: "Power Breakouts",  icon: ThumbsUp,       adminOnly: false, premium: true },
  { k: "strongest",   label: "Strongest",        icon: Lightning,      adminOnly: true },
  { k: "watchlist",   label: "Watchlist",        icon: Star,           adminOnly: false },
];

export default function DashboardSidebar({
  tab,
  setTab,
  watchlistCount = 0,
  isAdmin = false,
  mobileOpen = false,
  onMobileToggle,
}) {
  const items = TAB_ITEMS.filter((t) => !t.adminOnly || isAdmin);

  return (
    <>
      {/* Mobile toggle button (floats at top-left of content area) */}
      <button
        type="button"
        onClick={onMobileToggle}
        data-testid="sidebar-mobile-toggle"
        className="lg:hidden fixed top-[5.5rem] left-3 z-40 p-2 border border-subtle bg-app rounded-sm text-primary-fg hover:border-pos/40 shadow-md"
        aria-label={mobileOpen ? "Close menu" : "Open menu"}
      >
        {mobileOpen ? <X size={16} weight="bold" /> : <List size={16} weight="bold" />}
      </button>

      {/* Mobile backdrop */}
      {mobileOpen && (
        <button
          type="button"
          aria-label="Close menu"
          onClick={onMobileToggle}
          className="lg:hidden fixed inset-0 bg-black/40 backdrop-blur-sm z-30"
        />
      )}

      {/* Sidebar */}
      <aside
        data-testid="dashboard-sidebar"
        className={
          "border-r border-subtle bg-surface/40 backdrop-blur-sm flex flex-col py-4 transition-transform " +
          // Desktop: sticky on the left, always visible
          "lg:w-56 lg:shrink-0 lg:sticky lg:top-0 lg:self-start lg:h-[calc(100vh-0px)] lg:max-h-screen lg:overflow-y-auto lg:translate-x-0 " +
          // Mobile: fixed slide-in from left
          "fixed inset-y-0 left-0 z-30 w-64 " +
          (mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0")
        }
      >
        <div className="px-4 mb-3 text-[10px] font-mono uppercase tracking-[0.25em] text-muted-fg">
          /// Scanner Menu
        </div>
        <nav className="flex flex-col">
          {items.map((t) => {
            const Icon = t.icon;
            const active = tab === t.k;
            const badge =
              t.k === "watchlist" && watchlistCount > 0 ? watchlistCount : null;
            return (
              <button
                key={t.k}
                type="button"
                onClick={() => {
                  setTab(t.k);
                  if (mobileOpen && onMobileToggle) onMobileToggle();
                }}
                data-testid={`sidebar-tab-${t.k}`}
                className={
                  "group relative flex items-center gap-2.5 px-4 py-2.5 text-left transition border-l-2 text-xs font-mono uppercase tracking-widest " +
                  (active
                    ? "border-l-pos bg-pos-soft/30 text-pos"
                    : "border-l-transparent text-secondary-fg hover:bg-surface-hover/60 hover:text-primary-fg")
                }
              >
                <Icon
                  size={14}
                  weight={active ? "fill" : "regular"}
                  className="shrink-0"
                />
                <span className="flex-1 truncate normal-case font-sans text-[13px] font-medium">
                  {t.label}
                </span>
                {badge != null && (
                  <span className="text-[10px] font-mono tabular-nums text-pos">
                    {badge}
                  </span>
                )}
                {t.premium && (
                  <span
                    className="text-[8px] uppercase tracking-widest text-pos/80"
                    title="Premium feature"
                  >
                    ★
                  </span>
                )}
              </button>
            );
          })}
        </nav>

        <div className="mt-auto px-4 py-4 text-[10px] font-mono uppercase tracking-widest text-muted-fg/60 border-t border-subtle">
          Live · NSE EOD scanner
        </div>
      </aside>
    </>
  );
}
